export const ViewTypes = {
  Regular: 'regular',
  Occlusal: 'occlusal'
}

export const TeethTrackingStatuses = {
  Tracking: 'tracking',
  TrackingNoMovement: 'trackingNoMovement',
  TrackingNoMovementPlanned: 'trackingNoMovementPlanned',
  PartiallyTracking: 'partiallyTracking',
  NotTracking: 'notTracking',
  NoMovement: 'noMovement',
  NoSignificantMovement: 'noSignificantMovement',
  Unknown: 'unknown',
  MissingTooth: 'missingTooth',
  Fast: 'fast',
  Moderate: 'moderate',
  Slow: 'slow',
  MissingSpeedInfo: 'missingSpeedInfo',
  NegligiblePlan: 'negligiblePlan'
}

export const TreatmentSTLsStatuses = {
  PendingFilesTransfer: 'pending-files-transfer',
  Completed: 'completed'
}

// A scan/upload belongs to exactly one Tx Tracker mode. Mirrors the backend contract.
export const TrackingModes = {
  Active: 'active',
  Retention: 'retention'
}

// Lifecycle of a Retention reference entry inside Treatment.txTrackerRetentionStls.
export const RetentionReferenceStatuses = {
  Pending: 'pending',
  Ready: 'ready',
  Failed: 'failed'
}

// How a Retention reference set came to exist. Mirrors the backend contract.
export const RetentionReferenceSources = {
  PlannedFinalCopy: 'planned-final-copy',
  UploadedActualFinal: 'uploaded-actual-final'
}

export const StlProviders = {
  '3M': '3m',
  Spark: 'spark',
  uLab: 'ulab',
  Align: 'align',
  Angel: 'angel',
  KLOwen: 'klowen',
  ArchForm: 'archform',
  Tune: 'tune',
  Jooylign: 'jooylign',
  AlignersOtherFullPlan: 'alignersOtherFullPlan',
  AlignersOtherStartEnd: 'alignersOtherStartEnd',
  BracesOther: 'bracesOther',
  SolventumIntegration: 'solventum-integration',
  Other: 'other'
}

export const STL_BY_REQUEST_PROVIDERS = ['spark']
export const PROGRESS_TYPES = {
  Overall: 'Progress',
  Rotation: 'Rotation',
  Translation: 'Translation'
}

export const TxTrackerValidationSteps = {
  SelectProvider: 'selectProvider',
  PreUpload: 'preUpload'
}
